import {
  type ModerationDecisionBody,
  type ModerationDecisionResult,
  type ModerationItemDetail,
  type ModerationQueuePage,
  type ModerationSubject,
} from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const moderationEndpoints = {
  /** The verification (`organization`) or document audit queue, oldest first (R6). */
  moderationQueue(subject: ModerationSubject, params: Record<string, string> = {}) {
    const query = new URLSearchParams({ subject, ...params }).toString();
    return authenticated<ModerationQueuePage>(`${API_PREFIX}/admin/moderation/queue?${query}`);
  },

  /**
   * One queued item by id, with its status and decision history. New on the API: until
   * it ships this answers 404, and the detail screen falls back to the queue list.
   */
  moderationItem(itemId: string, subject: ModerationSubject) {
    const query = new URLSearchParams({ subject }).toString();
    return authenticated<ModerationItemDetail>(
      `${API_PREFIX}/admin/moderation/queue/${itemId}?${query}`,
    );
  },

  /** Approve or reject a queued item. A rejection carries a reason the requester is shown. */
  decideModeration(itemId: string, body: ModerationDecisionBody) {
    return authenticated<ModerationDecisionResult>(
      `${API_PREFIX}/admin/moderation/queue/${itemId}/decision`,
      { method: 'POST', body },
    );
  },
};
